import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import BlogCard from "../blog/BlogCard";
import { MotionDiv, StaggerGrid, StaggerItem } from "../../utils/animations";

import { BLOG_API as API } from "../../config/api";

function PostSkeleton() {
    return (
        <div className="blog-skeleton-card" aria-hidden="true">
            <div className="blog-skeleton-img" />
            <div className="blog-skeleton-body">
                <div className="blog-skeleton-line blog-skeleton-line--short" />
                <div className="blog-skeleton-line" />
                <div className="blog-skeleton-line blog-skeleton-line--medium" />
            </div>
        </div>
    );
}

function LatestPostsSection() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(`${API}/posts/`);
                const allPosts = response.data.results || response.data;
                setPosts(allPosts.slice(0, 3));
                setError(false);
            } catch (err) {
                console.error("Error fetching latest posts:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);


    return (
        <section className="py-24 relative z-10 bg-gradient-to-b from-transparent to-em-bgsoft">
            <div className="max-w-[1200px] mx-auto px-[clamp(1.25rem,5vw,3rem)]">
                <MotionDiv className="text-center mb-16">
                    <h2 className="text-[clamp(2rem,4vw,3.5rem)] font-black text-em-text leading-[1.1] mb-6">
                        Últimas Publicaciones
                    </h2>
                    <p className="text-[1.125rem] text-em-soft max-w-[600px] mx-auto leading-[1.6]">
                        Descubre nuestros artículos más recientes sobre tecnología, IA y desarrollo de software.
                    </p>
                </MotionDiv>

                {loading ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                        {[1, 2, 3].map((n) => (
                            <PostSkeleton key={n} />
                        ))}
                    </div>
                ) : error || posts.length === 0 ? (
                    <p className="text-center text-em-soft mb-12">
                        {error
                            ? "No pudimos cargar las publicaciones. Visita el "
                            : "Aún no hay publicaciones. Pronto encontrarás contenido en el "}{" "}
                        <Link to="/blog" className="text-em-accent hover:text-em-accent2">
                            blog
                        </Link>{" "}
                        para ver el contenido.
                    </p>
                ) : (
                    <StaggerGrid className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                        {posts.map((post) => (
                            <StaggerItem key={post.id} className="h-full">
                                <BlogCard post={post} />
                            </StaggerItem>
                        ))}
                    </StaggerGrid>
                )}

                <MotionDiv className="text-center" delay={0.15}>
                    <p className="text-em-soft text-sm max-w-xl mx-auto mb-6">
                        En el blog puedes buscar por palabras y ver todas las entradas por fecha.
                    </p>
                    <Link
                        to="/blog"
                        className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-em-vivid text-em-ink font-semibold rounded-lg hover:bg-em-vivid2 hover:-translate-y-1 transition-all"
                    >
                        Ver todos los artículos
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                            <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                        </svg>
                    </Link>
                </MotionDiv>
            </div>
        </section>
    );
}

export default LatestPostsSection;
